<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden auth-screen">

  <!-- Background Hero Layers -->
  <div class="auth-hero-bg position-absolute top-0 start-0 w-100 h-100"></div>
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>

  <!-- =========================
       CONTENT LAYER
  =========================== -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           RESET PASSWORD (Glass Card)
      =========================== -->
      <div
        class="glass-card glass-card-neon p-4 p-md-5 rounded-4 shadow-sm
               col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto"
      >

        <!-- Logo -->
        <div class="text-center mb-4">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>
        </div>

        <!-- Heading -->
        <h3 class="mb-1 text-center text-white">Reset Password</h3>
        <p class="text-center text-white-50 mb-4 text-sm">
          Enter your email and we’ll send you a link to reset your password.
        </p>

        <!-- ERROR MESSAGE -->
        <div
          v-if="error_message"
          class="alert alert-danger alert-dismissible fade show rounded-3 py-2 px-3 border-0 bg-danger text-white mb-4"
          role="alert"
          style="--bs-bg-opacity: 0.2; border: 1px solid rgba(255,107,107,0.3) !important;"
        >
          {{ error_message }}
          <button
            type="button"
            class="btn-close btn-close-white"
            @click="error_message = ''"
          ></button>
        </div>

        <!-- SUCCESS MESSAGE -->
        <div
          v-if="success_message"
          class="alert alert-success alert-dismissible fade show rounded-3 py-2 px-3 border-0 bg-success text-white mb-4"
          role="alert"
          style="--bs-bg-opacity: 0.2; border: 1px solid rgba(46,204,113,0.3) !important;"
        >
          {{ success_message }}
          <button
            type="button"
            class="btn-close btn-close-white"
            @click="success_message = ''"
          ></button>
        </div>

        <!-- LOADING STATE -->
        <div v-if="is_loading" class="text-center mb-4">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-white-50">Sending reset link...</span>
        </div>

        <!-- =========================
              RESET FORM
        =========================== -->
        <form @submit.prevent="handleReset" v-if="!is_loading">

          <!-- Email -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50">Email</label>
            <input
              v-model="email"
              type="email"
              class="form-control form-control-sm rounded-3
                    bg-transparent text-white border-secondary placeholder-white"
              placeholder="Enter email"
              required
              :disabled="is_loading"
            />
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1 w-100 fw-light mb-3"
            :disabled="is_loading"
          >
            Send Reset Link
          </button>

          <!-- Back to Login -->
          <p class="text-center text-white-50 text-xs mb-0">
            Remember your password?
            <router-link to="/login" class="text-decoration-none text-primary">
              Login
            </router-link>
          </p>

        </form>

      </div>
    </div>
  </div>
</div>

